import { Dispatch, SetStateAction } from 'react';
import { IInspectionCategory, IToolInspectionImageReq } from 'types/suscription/toolInspection.types';
import { IInitialFieldConfig, TToolInspectionParsedValue } from 'constants/toolInspection.constants';
import InspectionFieldsSection from './InspectionFieldsSection/InspectionFieldsSection';
import InspectionCommentSection from './InspectionCommentSection/InspectionCommentSection';
import PhotoEvidenceSection from './PhotoEvidenceSection/PhotoEvidenceSection';

import './ToolInformationSections.scss';

interface IToolInformationSectionsProps {
  productId?: number;
  formFields: Record<number, IInitialFieldConfig> | null;
  formImages: IToolInspectionImageReq[] | null;
  category: IInspectionCategory | null;
  onFieldChange: (id: number, value: TToolInspectionParsedValue) => void;
  disabled?: boolean;
  setFormImages: Dispatch<SetStateAction<IToolInspectionImageReq[]>>;
}

const ToolInformationSections = ({
  productId,
  formFields,
  formImages,
  category,
  onFieldChange,
  disabled = false,
  setFormImages
}: IToolInformationSectionsProps) => {
  return (
    <div className="toolInformationSections">
      {formFields && (
        <InspectionFieldsSection
          category={category}
          formFields={formFields}
          isDisabled={disabled}
          onFieldChange={onFieldChange}
        />
      )}

      {productId && (
        <PhotoEvidenceSection
          productId={productId}
          images={formImages}
          interactionDisabled={disabled}
          setFormImages={setFormImages}
        />
      )}

      {formFields && (
        <InspectionCommentSection formFields={formFields} onFieldChange={onFieldChange} isDisabled={disabled} />
      )}
    </div>
  );
};

export default ToolInformationSections;
